import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FirDiagnosticCenterService {

  constructor(private http: HttpClient) {}

  getUserAssign(adminUrl: string, params: any): Observable<any> {
    const url = `${adminUrl}/getUserAssign`;
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, String(params[key]));
      }
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
